export default "__VITE_ASSET__6141fd12__"